import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.496 4.136l-12 7a1 1 0 0 0 0 1.728l12 7a1 1 0 0 0 1.504 -.864v-14a1 1 0 0 0 -1.504 -.864z","key":"svg-0"}],["path",{"d":"M4 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z","key":"svg-1"}]]

const IconPlayerSkipBackFilled = createReactComponent('filled', 'player-skip-back-filled', 'PlayerSkipBackFilled', __iconNode);

export default IconPlayerSkipBackFilled;